import { Pipe, PipeTransform } from '@angular/core';

/**
 * Decodes HTML character references (named, decimal, hex) in a string and
 * returns plain text — safe for {{ }} interpolation, no XSS risk.
 *
 * Handles single-encoded:  Qu&#233;bec      → Québec
 * Handles hex-encoded:     Qu&#xE9;bec      → Québec
 * Handles named entities:  Qu&eacute;bec    → Québec
 * Handles double-encoded:  Qu&amp;#233;bec  → Québec
 *
 * Use instead of [innerHTML] | safeHtml when the value is plain text
 * (option labels, dropdown text, etc.) that may contain HTML entities
 * from the WCF/database layer.
 */
@Pipe({
    name: 'decodeHtml',
    standalone: true
})
export class DecodeHtmlPipe implements PipeTransform {

    transform(value: string | null | undefined): string {
        if (!value) return '';
        return this.decode(this.decode(value));
    }

    private decode(value: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }
}
